<h2 mat-dialog-title>
  {{'kontakt' | translate}}
  <button mat-icon-button color="primary" class="float-right mr-3" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div mat-dialog-content>
  <p>{{'w_razie_braku_loginu_i_hasla_prosimy_o_kontakt_pod'|translate}} <br>
    <span class="contact-data"> {{'przedstawicielem_handlowym' | translate}}</span>.
  </p>
</div>
